import zxcvbn from 'zxcvbn';

export const checkPasswordForError = (
  password: string = '',
  confirmPassword: string = '',
): { strength: number; error: string; isValid: boolean } => {
  const containsUppercase: boolean = /[A-Z]/.test(password);
  const containsLowercase: boolean = /[a-z]/.test(password);
  const containsNumber: boolean = /[0-9]/.test(password);
  const containsSpecial: boolean = /[#?!@$%^&*-]/.test(password);

  let error: string = '';

  if ((confirmPassword || password) && password !== confirmPassword) {
    error = 'Passwords must match';
  }

  if (password?.length < 10) {
    error = 'Password must be greater than 10 characters';
  }

  if (!containsUppercase) {
    error = 'Password must contains at least one uppercase.';
  }

  if (!containsLowercase) {
    error = 'Password must contains at least one lowercase.';
  }

  if (!containsNumber) {
    error = 'Password must contains at least one number.';
  }

  if (!containsSpecial) {
    error =
      'Password must contains at least one special character (#?!@$%^&*-).';
  }

  const zxcvbnResult = zxcvbn(password);

  return {
    strength: !!error ? Math.min(zxcvbnResult.score, 3) : zxcvbnResult.score,
    error,
    isValid: !error && zxcvbnResult.score === 4,
  };
};
